import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import {
  brandOverride,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { getTemperature } from '../../../../../../helper/temperature';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import convertSecondsToTime from '../../../../../../helper/convertSecondsToTime';
import { PoolInstallationAssistanceComponent } from '../../../../../../../../components/pool-installation-list/modals/pool-installation-assistance/pool-installation-assistance.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';

@Component({
  selector: 'app-p00058-filtration-statut',
  templateUrl: './p00058-filtration-statut.component.html',
  styleUrls: ['./p00058-filtration-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
    TranslatePipe,
    CollapseComponent,
  ],
})
export class P00058FiltrationStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  get hasAlarm(): boolean {
    return this.getValue('pvSAlarme') === 1;
  }

  getVitesse(property = 'pvSVitesseCouranteRPM'): string {
    const pvSVitesseCouranteRPM = this.getValue(property);
    const pvPUniteConsignePompe = this.getValue('pvPUniteConsignePompe');
    const pvSVitesseMaxRpm = this.getValue('pvSVitesseMaxRpm');

    if (pvSVitesseCouranteRPM === 0) {
      return this.translateService.instant('P0003601.card.status.stop');
    } else {
      if (pvPUniteConsignePompe === 0) {
        const pourcentage = Math.round(
          (pvSVitesseCouranteRPM * 100) / pvSVitesseMaxRpm,
        );
        return pourcentage + ' %';
      } else {
        return (
          pvSVitesseCouranteRPM +
          ' ' +
          this.translateService.instant('P00058.installation.rpm')
        );
      }
    }
  }

  getPompeFiltrationFonctionEntreeAsservi(): string {
    const pvSAvertissement = this.getValue('pvSAvertissement');
    const pvSConsigneAvertissement = this.getValue('pvSConsigneAvertissement');

    if (pvSAvertissement === 0) {
      return '--';
    }

    switch (pvSConsigneAvertissement) {
      case 0:
        return this.translateService.instant(
          'P00058.parameters.status.statut.pompeFiltrationFonctionEntreeAsservi.forceArret',
        );
      case 1:
        return this.getVitesse('pvPVitesseV1');
      case 2:
        return this.getVitesse('pvPVitesseV2');
      case 3:
        return this.getVitesse('pvPVitesseEcremage');
      case 4:
        return this.getVitesse('pvPVitesseV3');
      default:
        return '--';
    }
  }

  async onAssistancePress() {
    const modal = await this.slideModalController.create({
      component: PoolInstallationAssistanceComponent,
      componentProps: {
        productClass: this.productClass,
      },
    });

    await modal.present();
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly getTemperature = getTemperature;
  protected readonly transformHourToDayHour = transformHourToDayHour;
  protected readonly brandOverride = brandOverride;
  protected readonly convertSecondsToTime = convertSecondsToTime;
}
